import { useEffect, useState } from "react";
import Layout from "../Layout";
import DirectIcon from "../../assets/images/svg-icons-material-io/mail_lock_FILL0_wght400_GRAD0_opsz48.svg";
import OrgIcon from "../../assets/images/svg-icons-material-io/domain_FILL0_wght400_GRAD0_opsz48.svg";
import ReceivedMsgIcon from "../../assets/images/svg-icons-material-io/markunread_mailbox_FILL0_wght400_GRAD0_opsz48.svg";
import HeaderDashboard from "./HeaderDashboard";
import SubMenu from "../nav-admin/SubMenu/SubMenu";
import { Link, useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { usePortalAuthentication } from "../../services/authorizationService";

const Dashboard = () => {
  const {
    userRole,
    userToken,
    sharedObject,
    setUserSession,
    setSearchObj,
    SetSharedObject,
    userSession,
    setXDRArr,
    backendTarget,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
    setUserSession: state.setUserSession,
    setSearchObj: state.setSearchObj,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    setXDRArr: state.setXDRArr,
    backendTarget: state.backendTarget,
  }));
  const isGcpUser = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const [obj, setObj] = useState(false);
  const [flag, setFlag] = useState(false);
  const [processing, SetProcessing] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const navigate = useNavigate();
  const { logout } = usePortalAuthentication();
  const [emailCount, setEmailCount] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (userRole === "User") {
        logout();
      }
      getXDREndPoints();
      SetProcessing(true);
      let call = "/dashboard/GetDashboard";
      const res = await CallAPI(call, null, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res && res.status === "SUCCESS") {
        setObj(res.data);
        SetProcessing(false);
      } else if (res.status === "SERVERERROR") {
        let str =
          "A system error occurred searching for your results. Please contact support for further assistance.";
        SetMsg(str);
        SetErrMsg(true);
        SetProcessing(false);
      }
      if (userRole === "ADMINISTRATOR") {
        getDomains();
      }
    };
    fetchData();
    RunJob();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backendTarget]);
  const RunJob = async () => {
    let call = `/uploadStatus/RunUploadStatusJob`;
    const res = CallAPI(call, false, "get", userToken);
    if (res && res.status === "SUCCESS") {
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetProcessing(false);
    }
  };

  const getXDREndPoints = async () => {
    SetProcessing(true);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      await setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const getDomains = async () => {
    SetProcessing(true);
    SetErrMsg(false);
    let call = "/customers/GetUserDomains";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      let getDomain = res.data.data;
      let dmId = null;
      let dmName = null;
      if (getDomain.length === 1) {
        dmId = parseInt(getDomain[0].value);
        dmName = getDomain[0].text;
      } else {
        for (let dm of getDomain) {
          if (dm.text === userSession.domain_name) {
            dmId = dm.value;
            dmName = dm.text;
            break;
          }
        }
      }
      setUserSession({ ...userSession, domain_id: dmId, domain_name: dmName });
    } else if (res.status === "SERVERERROR") {
      let str =
        "A system error occurred searching for your results. Please contact support for further assistance.";
      SetMsg(str);
      SetErrMsg(true);
      SetProcessing(false);
    }
  };
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const tileLabel = (title, subtitle) =>
    subtitle ? `${title} - ${subtitle}` : title;

  const hasEmails =
    sharedObject.getUserEmails && sharedObject.getUserEmails.length > 0;

  return (
    <Layout>
      <main id="main-content" tabIndex={-1}>
        {userRole !== "SES ADMINISTRATOR" &&
        userRole !== "ADMINISTRATOR" &&
        userRole !== "SYSTEMADMINISTRATOR" ? null : (
          <HeaderDashboard />
        )}
        {errMsg ? (
          <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
            {msg}
          </div>
        ) : null}
        <section className="dashboard-container" aria-label="Dashboard shortcuts">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" &&
          !userSession?.is_gcp_user ? (
            <button
              type="button"
              className="btn btn-primary dash-box box-direct animate slide delay-1"
              aria-label="Direct Webmail"
              onClick={(el) => {
                if (window !== "undefined") {
                  if (
                    sharedObject.getUserEmails &&
                    sharedObject.getUserEmails.length > 0
                  ) {
                    window.open("../webmail", "_self");
                  } else {
                    setFlag("/no-direct-email");
                  }
                }
              }}
              
            >
              <div className="box-icon" aria-hidden="true">
                <img
                  src={DirectIcon}
                  className="filter-white"
                  alt=""
                />
              </div>
              <div className="box-bottom" aria-hidden="true">
                <div className="title">Direct</div>
                <div className="sub-title">Webmail</div>
              </div>
            </button>
          ) : null}

          {/* Organizations Box*/}
          <button
            type="button"
            className="btn btn-primary dash-box box-org animate slide delay-2"
                    aria-label={tileLabel(
                        "Organizations",
                        `Total: ${userRole === "SES ADMINISTRATOR" ||
                            userRole === "SYSTEMADMINISTRATOR"
                            ? obj?.data?.totalAdminOrgCount ?? ""
                            : sharedObject?.getOrgsObj?.length ?? ""
                        }`
                    )}
            onClick={(el) => {
              setSearchObj([]);
              SetSharedObject("xdrSettiingObj", {});
              SetSharedObject("custumerRecord", {});
              SetSharedObject("orgActionObj", false);
              setFlag("/organizations");
            }}
          >
            <div className="box-icon" aria-hidden="true">
              <img
                src={OrgIcon}
                className="filter-white"
                alt=""
              />
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">Organizations</div>
              <div className="sub-title">
                Total:{" "}
                {userRole === "SES ADMINISTRATOR" ||
                userRole === "SYSTEMADMINISTRATOR"
                  ? obj?.data?.totalAdminOrgCount
                  : sharedObject?.getOrgsObj?.length}
              </div>
            </div>
          </button>

          {/*Users Box*/}
          <button
            type="button"
            className="btn btn-primary dash-box box-users animate slide delay-3"
            aria-label={tileLabel(
              "Users",
              `Total: ${obj?.data?.totalAdminUserCount ?? ""}`
            )}
            onClick={(el) => {
              SetSharedObject("UserIdEmail", {});
              setFlag("/users");
            }}

          >
            <div className="box-icon" aria-hidden="true">
              <i className="bi bi-people" aria-hidden="true"></i>
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">Users</div>
              <div className="sub-title">
                Total: {obj?.data?.totalAdminUserCount}
              </div>
            </div>
          </button>

          {/*Emails Box*/}
          {/* CPPCON-1140 disabled this for GCP users; temporarily re-enabled, untied to a
              ticket, so other devs can test the Emails module on GCP through QA. Not for
              merge to master/Dev — revert to the CPPCON-1140 disabled state before that. */}
          <button
            className="btn btn-primary dash-box box-customer animate slide delay-8"
            type="button"
            aria-label="Emails"
            onClick={(el) => {
              SetSharedObject("UserIdEmail", {});
              setFlag("/emails");
            }}
          >
            <div className="box-icon" aria-hidden="true">
              <i className="bi bi-envelope-at-fill" ></i>
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">Emails</div>
              <div className="sub-title"></div>
            </div>
          </button>

          {/*Sent Message Reports Box*/}
          <button
            type="button"
            className={`btn btn-primary dash-box box-sentmsg animate slide delay-4${isGcpUser ? " dash-box-disabled" : ""}`}
            aria-label={isGcpUser ? "Sent Message Reports - not available" : tileLabel("Sent Message", "Reports")}
            disabled={isGcpUser}
            aria-disabled={isGcpUser}
            onClick={(el) => {
              if (isGcpUser) return;
              SetSharedObject("sentMessageStatusResults", {});
              SetSharedObject("messageStatusSearch", {});
              SetSharedObject("SentSearchType", "");
              setFlag("/sent-message");
            }}

          >
            <div className="box-icon" aria-hidden="true">
              <i className="bi bi-send-check" ></i>
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">Sent Message</div>
              <div className="sub-title">Reports</div>
            </div>
          </button>

          {/*Received Message Reports Box*/}
          <button
            type="button"
            className={`btn btn-primary dash-box box-receivedmsg animate slide delay-5${isGcpUser ? " dash-box-disabled" : ""}`}
            aria-label={isGcpUser ? "Received Message Reports - not available" : tileLabel("Received Message", "Reports")}
            disabled={isGcpUser}
            aria-disabled={isGcpUser}
            onClick={(el) => {
              if (isGcpUser) return;
              SetSharedObject("recievedMessageStatusResults", {});
              SetSharedObject("messageStatusSearch", {});
              SetSharedObject("SentSearchType", "");
              setFlag("/received-message");
            }}

          >
            <div className="box-icon" aria-hidden="true">
              <img
                src={ReceivedMsgIcon}
                className="filter-white"
                alt=""
              />
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">Received Message</div>
              <div className="sub-title">Reports</div>
            </div>
          </button>

          {/*Download Status Box*/}
          <button
            type="button"
            className={`btn btn-primary dash-box box-status animate slide delay-6${isGcpUser ? " dash-box-disabled" : ""}`}
            aria-label={isGcpUser ? "Download Status Reports - not available" : tileLabel("Download Status", "Reports")}
            disabled={isGcpUser}
            aria-disabled={isGcpUser}
            onClick={(el) => {
              if (isGcpUser) return;
              setFlag("/download-status");
            }}
          >
            <div className="box-icon" aria-hidden="true">
              <i className="bi bi-download"></i>
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">Download Status</div>
              <div className="sub-title">Reports</div>
            </div>
          </button>
          {/*User Reports Box*/}
          <button
            className={`btn btn-primary dash-box box-reports animate slide delay-7${isGcpUser ? " dash-box-disabled" : ""}`}
            data-toggle={isGcpUser ? undefined : "collapse"}
            type="button"
            aria-label={isGcpUser ? "User Reports - not available" : "User Reports"}
            data-target={isGcpUser ? undefined : "#btnUserReport"}
            aria-controls="btnUserReport"
            aria-expanded="false"
            disabled={isGcpUser}
            aria-disabled={isGcpUser}
            onClick={(el) => {
              if (isGcpUser) return;
              SetSharedObject("UserActiviySearch", {});
            }}
          >
            <div className="box-icon" aria-hidden="true">
              <i className="bi bi-file-bar-graph"></i>
            </div>
            <div className="box-bottom" aria-hidden="true">
              <div className="title">User</div>
              <div className="sub-title">Reports</div>
            </div>
          </button>

          {/*Customers Box*/}
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <button
              type="button"
              className="btn btn-primary dash-box box-customer animate slide delay-8"
              aria-label="Customers"
              onClick={(el) => {
                setFlag("/customers");
              }}
            >
              <div className="box-icon" aria-hidden="true">
                <i className="bi bi-globe2"></i>
              </div>
              <div className="box-bottom" aria-hidden="true">
                <div className="title">Customers</div>
                <div className="sub-title"></div>
              </div>
            </button>
          )}
        </section>
        <SubMenu />
        {processing && (
          <div 
              className="loader-container" 
              role="status" 
              aria-live="polite" 
              aria-atomic="true"
              aria-labelledby="dashboard-loader-id"
          >
              <div className="spinner" aria-hidden="true"></div>
              <div className="loading-text" id="dashboard-loader-id">{loadingText}</div>
          </div>
        )}
      </main>
    </Layout>
  );
};

export default Dashboard;
